import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleCliente } from "../hooks/roles/ProtectedRoleCliente";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const NuevaTareaProgramada = React.lazy(
  () => import("../screean/services/nueva-tarea-programada")
);
export function nuevaTareaProgramada() {
  return (
    <Route
      path="/nueva-tarea-programada"
      element={
        <LazySuspense>
          {" "}
          <ProtectedRoute>
            <ProtectedRoleCliente>
              <LazySuspense>
                <NuevaTareaProgramada />
              </LazySuspense>
            </ProtectedRoleCliente>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
